import type { SVGProps } from 'react';

export const SvgIconChatbot = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="0.853448" y="0.853448" width="46.2931" height="46.2931" rx="23.1466" fill="white"></rect>
    <rect
      x="0.853448"
      y="0.853448"
      width="46.2931"
      height="46.2931"
      rx="23.1466"
      stroke="#FF001A"
      strokeWidth="1.7069"></rect>
    <path
      d="M33.1406 22.9984H30.1406C29.7428 22.9984 29.3613 23.1564 29.08 23.4377C28.7987 23.719 28.6406 24.1005 28.6406 24.4984V28.2484C28.6406 28.6462 28.7987 29.0277 29.08 29.309C29.3613 29.5903 29.7428 29.7484 30.1406 29.7484H31.6406C32.0384 29.7484 32.42 29.5903 32.7013 29.309C32.9826 29.0277 33.1406 28.6462 33.1406 28.2484V22.9984ZM33.1406 22.9984C33.1407 21.8101 32.9054 20.6336 32.4484 19.5368C31.9915 18.4399 31.3218 17.4444 30.4781 16.6077C29.6344 15.771 28.6334 15.1097 27.5328 14.6618C26.4322 14.2139 25.2538 13.9885 24.0656 13.9984C22.8782 13.9897 21.7008 14.2161 20.6013 14.6645C19.5018 15.1129 18.5019 15.7745 17.6592 16.6111C16.8165 17.4477 16.1477 18.4428 15.6913 19.539C15.2349 20.6352 15 21.8109 15 22.9984V28.2484C15 28.6462 15.158 29.0277 15.4393 29.309C15.7206 29.5903 16.1022 29.7484 16.5 29.7484H18C18.3978 29.7484 18.7794 29.5903 19.0607 29.309C19.342 29.0277 19.5 28.6462 19.5 28.2484V24.4984C19.5 24.1005 19.342 23.719 19.0607 23.4377C18.7794 23.1564 18.3978 22.9984 18 22.9984H15"
      stroke="#FF001A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M33.1406 28.248V30.498C33.1406 31.2937 32.8246 32.0568 32.2619 32.6194C31.6993 33.182 30.9363 33.498 30.1406 33.498H24.75"
      stroke="#FF001A"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"></path>
  </svg>
);
